import { Layout, Typography } from "antd";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { findModel } from "../../components/templates/main-template/MainTamplate.utils";
import { GlobalActions } from "../../components/molecules";
import { useModels } from "./navigation";
import { useTasksStats } from "./useTasksStats";
import { NotificationBell } from "./NotificationBell";

// Top bar: current model name + notification bell with attention counters.
// Preserves the legacy global actions (e.g. "Pobierz baze" for okmar_admins)
// that used to live in the old header.
export const AppTopbar: React.FC = () => {
  const location = useLocation();
  const models = useModels();
  const { data } = useTasksStats();

  const { model } = useMemo(
    () => findModel(models, location.pathname.slice(1)),
    [models, location]
  );

  return (
    <Layout.Header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 900,
        height: 52,
        lineHeight: "normal",
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #e8e8e6",
      }}
    >
      <Typography.Text strong style={{ fontSize: 15 }} ellipsis>
        {model?.name ?? ""}
      </Typography.Text>
      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 12 }}>
        <GlobalActions total={1} global_actions={data?.global_actions ?? []} />
        <NotificationBell />
      </div>
    </Layout.Header>
  );
};
